import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Spin, Tag, message } from 'antd'
import { renderPhoneStr, renderTextStr, formatDay } from '@/utils/renderUtils'
import { fetchTuinaTherapist } from '@/redux/tuina/therapistDetailSlice'
import { TUINA_GENDER_OPTIONS, TUINA_THERAPIST_STATUS_OPTIONS } from '@/views/tuina/options'
import './TherapistDetail.less'

class TherapistDetail extends React.Component {
  static propTypes = {
    record: PropTypes.object,
    therapistDetail: PropTypes.object,
    getJStoreList: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    const { record, dispatch } = this.props
    if (record == null || record.id == null || record.id === '') return
    dispatch(fetchTuinaTherapist({ query: { id: record.id } }))
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载师傅详情失败'))
  }

  storeName = (storeId) => {
    const options = this.props.getJStoreList.data
    if (!Array.isArray(options)) return storeId
    const row = options.find((item) => String(item.id) === String(storeId))
    return row ? row.value : storeId
  }

  renderStatus = (v) => {
    const row = TUINA_THERAPIST_STATUS_OPTIONS.find((item) => item.id === v)
    const text = (row && row.value) || v
    if (!text) return null
    return <Tag color={row && row.color}>{text}</Tag>
  }

  renderAvatar = (raw, name) => {
    const url = raw == null ? '' : String(raw).trim()
    if (url) {
      return (
        <img
          className="tuina-tech-detail-avatar"
          src={url}
          alt={name || ''}
        />
      )
    }
    const ch = name == null ? '' : String(name).trim().charAt(0)
    if (!ch) {
      return <span className="tuina-tech-detail-avatar is-empty" />
    }
    return <span className="tuina-tech-detail-avatar is-initial">{ch}</span>
  }

  render () {
    const { record, therapistDetail } = this.props
    const { fetching, data } = therapistDetail
    const row = record || {}
    const view = data && data.id != null && String(data.id) === String(row.id) ? data : row
    const intro = view.intro == null ? '' : String(view.intro).trim()
    const genderRow = TUINA_GENDER_OPTIONS.find((item) => item.id === view.gender || item.id === Number(view.gender))

    return (
      <Spin spinning={fetching}>
        <div className="tuina-tech-detail">
          <div className="tuina-tech-detail-head">
            {this.renderAvatar(view.avatarUrl, view.name)}
            <div className="tuina-tech-detail-id">
              <div className="tuina-tech-detail-name-row">
                <h2 className="tuina-tech-detail-name">{renderTextStr(view.name)}</h2>
                {this.renderStatus(view.status)}
              </div>
              <p className="tuina-tech-detail-meta">{renderTextStr(view.therapistNo)}</p>
              <p className="tuina-tech-detail-meta">{renderTextStr(this.storeName(view.storeId))}</p>
            </div>
          </div>
          {intro ? (
            <p className="tuina-tech-detail-intro">{intro}</p>
          ) : null}
          <dl className="tuina-tech-detail-fields">
            <div>
              <dt>手机号</dt>
              <dd>{renderPhoneStr(view.phone)}</dd>
            </div>
            <div>
              <dt>性别</dt>
              <dd>{renderTextStr(genderRow && genderRow.value)}</dd>
            </div>
            <div>
              <dt>入职</dt>
              <dd>{formatDay(view.joinedAt)}</dd>
            </div>
          </dl>
        </div>
      </Spin>
    )
  }
}

const mapStateToProps = (state) => ({
  therapistDetail: state.tuina.therapistDetail,
  getJStoreList: state.components.getJStoreList
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(TherapistDetail)
